import { HttpMethod, httpClient } from './http-client';
import { TaskCard, TaskTypes } from '../@types/task.type';

export interface TaskApproveData {
  id: number;
  isApprove: boolean;
}

export interface TaskApproveResponse {
  success: boolean;
}

export const getTaskByServiceId = (serviceId: number): Promise<TaskCard[]> => {
  return httpClient<TaskCard[]>(`/tasksByServiceId/${serviceId}`, HttpMethod.Get);
};

export const createAndUpdateTask = (taskCardObject: TaskCard): Promise<TaskCard> => {
  return httpClient<TaskCard>('/task', HttpMethod.Post, taskCardObject);
};

export const createTaskServiceLogByApprove = (serviceLogId: number, data: TaskApproveData): Promise<TaskApproveResponse> => {
  return httpClient<TaskApproveResponse>(`/tasks/serviceLogs/${serviceLogId}/approve`, HttpMethod.Post, data);
};

export const deleteTaskById = (id: number): Promise<void> => {
  return httpClient<void>(`/task/${id}`, HttpMethod.Delete);
};

export const getTaskTypes = (serviceId: number): Promise<TaskTypes[]> => {
  return httpClient<TaskTypes[]>(`/taskTypes?serviceId=${serviceId}`, HttpMethod.Get);
};
